import { withConsentPilot } from "../../utils/consent";
import { useTrialPaymentOffer } from "../../hooks/useTrialPaymentOffer";
import { getPaywallPricingContext } from "../../utils/paywallPricing";

import { getPostPurchaseRedirect } from "../../utils/postPurchaseRedirect";
import { useUpsellV2Entry } from "../../hooks/useUpsellV2Entry";
// Small change for git push test
import React, { useState, useRef, useEffect } from "react";
import { container } from "./../../constants/styles";
import logoImg from "./../../assets/images/logo1.png";
import welcomeImg from "./../../assets/images/main.png";
import readyImg from "./../../assets/images/ready.png";
import buttonImg from "./../../assets/images/button.png";
import stopImg from "./../../assets/images/stop_wasting.png";
import beforeImg from "./../../assets/images/before.png";

import freeGiftImg from "./../../assets/images/free_gift.png";
import analyzetImg from "./../../assets/images/analyzed.png";
import toolsImg from "./../../assets/images/tools.png";
import seeImg from "./../../assets/images/see.png";
import resultImg from "./../../assets/images/result.png";
import mediaImg from "./../../assets/images/media.png";
import bloggersImg from "./../../assets/images/bloggers.png";
import visaImg from "./../../assets/images/mb_visa.png";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "../../utils/checkoutStripe";
import Form from "../../components/Form/Form";
import { useSelector } from "react-redux";
import Button from "../../components/Button/Button";
import Popup from "../../components/Popup/Popup";
import AppleGooglePayButton from "../../components/AppleGooglePayButton/AppleGooglePayButton";
import NotificationCarousel from "../../components/NotificationCarousel/NotificationCarousel";
import { useScrollToRef } from "../../hooks/useScrollToRef";
import {
  REDIRECT_LINK,
  STRIPE_PRICE_ID,
  STRIPE_PUBLIC_KEY,
} from "../../constants/formConstants";
import discountImg from "./../../assets/images/common/discount.svg";
import { useTimer } from "../../hooks/useTimer";
import { useIsInViewport } from "../../hooks/useIsInViewPort";
import cosmoImg from "./../../assets/images/cosmo.png";
import vogueImg from "./../../assets/images/vogue.png";
import marieclaireImg from "./../../assets/images/marieclaire.png";
import elleImg from "./../../assets/images/elle.png";
import { useClientReferenceCookie } from "../../hooks/useClientReferenceCookie";

function PaywallV2() {
  const [plan, setPlan] = useState("0.99");
  const trialOffer = useTrialPaymentOffer(getPaywallPricingContext("/v1", ""), { enabled: plan === "0.99" });
  const pricing = trialOffer.pricing;
  const discountBlockRef = useRef(null);
  const heresWhatYouGetRef = useRef(null);
  const formattedTime = useTimer(10);

  const scrollToRef = useScrollToRef();
  const { elementRef: trustSectionRef, isInViewPort: isTrustSectionVisible, wasInViewPort: wasTrustSectionVisible } = useIsInViewport();
  
  const [showStickyButton, setShowStickyButton] = useState(false);

  useClientReferenceCookie();

  // Set page title and meta description
  useEffect(() => {
    document.title = "Get Your Seasonal Color Analysis for only $1";
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = "Unlock your personalized seasonal color analysis results. Discover your perfect color palette and transform your style today.";
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (heresWhatYouGetRef.current) {
        const rect = heresWhatYouGetRef.current.getBoundingClientRect();
        // Show button only when user has scrolled past the section start (section top is at or above viewport top)
        const isAtOrBelowSection = rect.top <= 0;
        setShowStickyButton(isAtOrBelowSection);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial position

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const landingPlans = [
    {
      value: "0.99",
      text: pricing.trialDisplay,
      trialValue: 0.99,
      trialValueText: pricing.trialValueText,
      willBeText:
        "Then your yearly Subscription Period will start and you will be charged $27.99 every quarter. No refunds if canceled before the end of Subscription Period.",
    },
    {
      value: "9.78",
      text: "$9.78",
      trialValue: 9.78,
      trialValueText: "$9.78",
      willBeText:
        "Then your yearly Subscription Period will start and you will be charged $27.99 every quarter. No refunds if canceled before the end of Subscription Period.",
    },
  ];

  const [stripePromise, setStripePromise] = useState(() =>
    loadStripe(STRIPE_PUBLIC_KEY)
  );

  // V1 route always has $1 plan preselected

  const [isPopupOpen, setPopupOpen] = useState(false);
  const [showPromoCode, setShowPromoCode] = useState(false);

  const isApplePayAvailible = useSelector(
    (state) => state.payment.isApplePayAvailible
  );

  const onGetClick = () => {
    if (heresWhatYouGetRef.current) {
      scrollToRef(heresWhatYouGetRef, 100);
      return;
    }
  };

  const onPlanClick = (plan) => {
    if (!trialOffer.busy) setPlan(plan.value);
  };

  const onClosePopupClick = () => {
    if (!trialOffer.busy) setPopupOpen(false);
  };

  const onPopupOpenClick = () => {
    setPopupOpen(true);
  };

  const onSuccess = useUpsellV2Entry({
    currency: "usd",
    onLegacySuccess: () => {
      window.location.href = withConsentPilot(getPostPurchaseRedirect(REDIRECT_LINK, window.location.search));
    },
  });

  const renderFullForm = (onlyApplePay) => {
    return (
      <div className={`max-w-[450px] mx-auto`}>
        <Elements stripe={stripePromise}>
          <Form
            trialOffer={plan === "0.99" ? trialOffer : undefined}
            paymentAmount={plan === "0.99" ? pricing.amount : undefined}
            paymentValue={plan === "0.99" ? pricing.purchaseValue : undefined}
            priceID={STRIPE_PRICE_ID}
            trialCost={plan}
            littleText={"little text"}
            title={""}
            onlyApplePay={onlyApplePay}
            successAction={onSuccess}
          />
        </Elements>
      </div>
    );
  };

  const renderPopupForm = () => {
    return (
      <div>
        <h3 className="text-[24px] font-[700] text-[rgb(0,46,56)] mb-2">
          Payment method
        </h3>
        <p className="text-[12px] text-[rgb(50,87,97)]">
          {" "}
          You will only be charged {trialOffer.offer?.paymentMode === "split_trial_v1" ? pricing.trialDisplay : `$${plan}`}
        </p>
        {renderFullForm()}
      </div>
    );
  };

  const TimerRender = () => {
    return (
      <div className="bg-gradient-to-r from-[#FFE6D1] to-[#FFB6B9]/20 h-14 w-full flex items-center">
        <div className="font-['Inter',system-ui,-apple-system,sans-serif] text-center w-full">
          <p className="text-sm font-medium text-[#6B7280] leading-normal">
            Color Analysis results only <span className="font-bold text-[#7C3A8D]">$1.00!</span> Offer ends in:
          </p>
          <p className="text-2xl font-extrabold text-[#7C3A8D] leading-tight tracking-tight">
            {formattedTime}
          </p>
        </div>
      </div>
    );
  };

  const getSeasonalPromoCode = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;

    let season = "";

    if (month >= 3 && month <= 5) {
      season = "SPRING";
    } else if (month >= 6 && month <= 8) {
      season = "SUMMER";
    } else if (month >= 9 && month <= 11) {
      season = "FALL";
    } else {
      season = "WINTER";
    }

    return `${season}${year}`;
  };

  const discountBlockRender = () => {
    return (
      <div>
        <div className="mb-1 flex items-center justify-between">
          <p className="text-[18px] font-[800] text-[#0A364A]">
            Promo code applied
          </p>
          <div
            onClick={() => scrollToRef(discountBlockRef, 100)}
            className="flex cursor-pointer items-center rounded-[8px] bg-[#08A0C8] px-3 py-[10px] text-[18px] font-[800] text-[#ffffff]"
          >
            <img src={discountImg} className="mr-1 min-w-5" alt="discount" />
            <p>{getSeasonalPromoCode()}</p>
          </div>
        </div>
        <div className="flex items-center justify-between">
          <p className="text-[16px] font-[500] text-[#0A364A]">
            Promo code reserved for:
          </p>
          <p className="text-[16px] font-[500] text-[#0A364A]">
            {formattedTime}
          </p>
        </div>
      </div>
    );
  };

      return (
      <div>
      {/* Sticky wrapper for notification and timer sections */}
      <div className="sticky top-0 z-50">
        {/* Top notification banner */}
        <div className="w-full bg-gradient-to-r from-[#F8F6F0] to-white border-b border-[#7C3A8D]/20 cursor-pointer" onClick={onGetClick}>
          <NotificationCarousel />
        </div>
        
        {/* Timer section */}
        <div className="w-full bg-gradient-to-r from-[#F8F6F0] to-[#FFE6D1] border-b border-[#7C3A8D]/10 cursor-pointer" onClick={onGetClick}>
          <div className="py-2 font-['Inter',system-ui,-apple-system,sans-serif] text-center">
            <p className="text-sm font-medium text-[#374151] leading-normal">
              Color Analysis results only <span className="font-bold text-[#7C3A8D]">$1.00!</span> Offer ends in:
            </p>
            <p className="text-lg font-extrabold text-[#7C3A8D] leading-tight tracking-tight">
              {formattedTime}
            </p>
          </div>
        </div>
      </div>
      
      <div className={`${container} pt-3 pb-6`}>

      <div className="flex justify-center mb-2">
        <img src={logoImg} alt="logo" className="max-w-[44px]" />
      </div>

      <div className="flex justify-center mb-2">
        <div className="text-center max-w-[500px] font-['Inter',system-ui,-apple-system,sans-serif]">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#111827] leading-tight tracking-tight mb-0.5">
            Your Personalized
          </h2>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#7C3A8D] leading-tight tracking-tight mb-1">
            Color Analysis & Palette
          </h2>
          <div className="flex items-center justify-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#111827] leading-tight tracking-tight mr-2">
              are Ready
            </h2>
            <span className="text-2xl sm:text-3xl">😍</span>
          </div>
        </div>
      </div>

      <div className="flex justify-center mb-3">
        <img src={welcomeImg} alt="welcome" className="max-w-full w-[500px]" />
      </div>

      <div className="flex justify-center mb-3">
        <Button
          buttonStyles={`bg-[#7C3A8D] hover:bg-[#A259B5] text-white px-8 py-3 rounded-md font-bold text-base max-w-[350px] mb-4 inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-[#7C3A8D] focus:ring-offset-2 transition-colors duration-200`}
          text="GET MY COLORS NOW!"
          blick={false}
          action={() => onGetClick()}
        />
      </div>

      <div className="flex justify-center mb-8 px-2">
        <div ref={heresWhatYouGetRef} className="max-w-[900px] w-full rounded-lg border-2 border-[#7C3A8D]/20 bg-gradient-to-br from-[#F8F6F0] to-white p-6 shadow-lg font-['Inter',system-ui,-apple-system,sans-serif]">
          <h2 className="text-lg sm:text-xl font-bold text-center mb-6">
            <span className="text-[#111827]">Here's What </span>
            <span className="text-[#7C3A8D]">You Get</span>
          </h2>
          
          <div className="space-y-2 mb-3">
            <div className="flex items-start">
              <div className="flex-shrink-0 w-5 h-5 bg-[#FFE6D1] rounded-sm flex items-center justify-center mr-3 mt-0.5">
                <span className="text-[#7C3A8D] text-xs font-bold">✓</span>
              </div>
              <p className="text-base text-[#6B7280] leading-relaxed text-left">
                <span className="font-bold text-[#7C3A8D]">Color palette with 99% accuracy</span>
              </p>
            </div>
            
            <div className="flex items-start">
              <div className="flex-shrink-0 w-5 h-5 bg-[#FFE6D1] rounded-sm flex items-center justify-center mr-3 mt-0.5">
                <span className="text-[#7C3A8D] text-xs font-bold">✓</span>
              </div>
              <p className="text-base text-[#6B7280] leading-relaxed text-left">
                <span className="font-bold text-[#7C3A8D]">Clear color explanation</span> — Understand exactly why these shades suit you.
              </p>
            </div>
            
            <div className="flex items-start">
              <div className="flex-shrink-0 w-5 h-5 bg-[#FFE6D1] rounded-sm flex items-center justify-center mr-3 mt-0.5">
                <span className="text-[#7C3A8D] text-xs font-bold">✓</span>
              </div>
              <p className="text-base text-[#6B7280] leading-relaxed text-left">
                <span className="font-bold text-[#7C3A8D]">AI color try-on</span> — Instantly preview colors on yourself.
              </p>
            </div>
            
            <div className="flex items-start">
              <div className="flex-shrink-0 w-5 h-5 bg-[#FFE6D1] rounded-sm flex items-center justify-center mr-3 mt-0.5">
                <span className="text-[#7C3A8D] text-xs font-bold">✓</span>
              </div>
              <p className="text-base text-[#6B7280] leading-relaxed text-left">
                <span className="font-bold text-[#7C3A8D]">Outfit try-on</span> — Explore styles tailored to your season ✨
              </p>
            </div>
            
            <div className="flex items-start">
              <div className="flex-shrink-0 w-5 h-5 bg-[#FFE6D1] rounded-sm flex items-center justify-center mr-3 mt-0.5">
                <span className="text-[#7C3A8D] text-xs font-bold">✓</span>
              </div>
              <p className="text-base text-[#6B7280] leading-relaxed text-left">
                <span className="font-bold text-[#7C3A8D]">Style Assistant</span> — Get AI feedback on every outfit you try
              </p>
            </div>
          </div>

          {/* Promo Code Section */}
          <div className="bg-gradient-to-r from-[#7C3A8D]/10 to-[#FFB6B9]/10 rounded-lg p-2 mb-2 border border-[#7C3A8D]/20">
            <div className="flex items-center mb-2">
              <div className="w-8 h-8 bg-[#7C3A8D] rounded-md flex items-center justify-center mr-3">
                <span className="text-white text-lg">🎁</span>
              </div>
              <div>
                <p className="font-bold text-[#7C3A8D] text-sm">Promo Code Season26 Applied</p>
                <p className="text-sm text-[#6B7280] text-left">You save 85%</p>
              </div>
            </div>
          </div>

          {/* Pricing Section */}
          <div className="flex justify-between items-center mb-3 pb-4 border-b border-[#7C3A8D]/20">
            <span className="text-sm font-semibold text-[#111827]">Total due today:</span>
            <div className="text-right">
              <span className="text-sm text-[#9CA3AF] line-through mr-2">$6.99</span>
              <span className="text-lg font-bold text-[#7C3A8D]">$1.00</span>
            </div>
          </div>

          {/* Payment Buttons */}
          <div className="space-y-1 mb-6">
            {/* Apple Pay and Google Pay */}
            <Elements stripe={stripePromise}>
              <AppleGooglePayButton
            trialOffer={plan === "0.99" ? trialOffer : undefined}
            paymentAmount={plan === "0.99" ? pricing.amount : undefined}
            paymentValue={plan === "0.99" ? pricing.purchaseValue : undefined}
                trialCost={plan}
                onSuccess={onSuccess}
                isDisabled={false}
              />
            </Elements>
            
            {/* Credit/Debit Card Button */}
            <Button
              buttonStyles="w-full bg-[#7C3A8D] hover:bg-[#A259B5] text-white px-6 py-4 rounded-md font-semibold text-base inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-[#7C3A8D] focus:ring-offset-2 transition-colors duration-200"
              text="💳 Credit or Debit Card"
              isButtonDisabled={false}
              action={() => onPopupOpenClick()}
            />
          </div>

          {/* Terms Text */}
          <p className="text-[#9CA3AF] text-xs leading-relaxed text-left">
            By continue you agree that after the 7-day trial period ends,
            Color-analysis.pro will automatically continue your membership
            and charge 29.99$ every 2 months until you cancel it online in
            the{" "}
            personal account{" "}
            or by email. Learn more about cancellation and refund policy in{" "}
            Terms
            .
          </p>
        </div>
      </div>

      {/* Trust Section with Frame */}
      <div ref={trustSectionRef} className="flex justify-center mb-8 px-2">
        <div className="max-w-[900px] w-full rounded-lg border-2 border-[#7C3A8D]/20 bg-gradient-to-br from-[#F8F6F0] to-white p-6 shadow-lg font-['Inter',system-ui,-apple-system,sans-serif]">
          
          {/* Statistics Section */}
          <div className="mb-6 pb-4 border-b border-[#7C3A8D]/20">
            <div className="text-left">
              <p className="text-lg font-medium text-[#111827] mb-1">Over <span className="font-bold text-[#7C3A8D]">348</span> tests taken today</p>
              <p className="text-base text-[#111827]">Most popular today: <span className="font-semibold text-[#7C3A8D]">Soft Autumn</span></p>
            </div>
          </div>

          {/* Why You Can Trust Section */}
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-[#111827] mb-6 text-left tracking-wide font-['Inter',system-ui,-apple-system,sans-serif]">
              Why <span className="text-[#7C3A8D]">You Can Trust</span> ColorAnalysis Pro
            </h2>
            
            <div className="space-y-4">
              {/* Trust Point 1 */}
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#FFE6D1] rounded-lg flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-[#7C3A8D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div className="text-left">
                  <h4 className="font-bold text-[#111827] mb-1 text-left font-['Inter',system-ui,-apple-system,sans-serif]">Proven Color Theory System</h4>
                  <p className="text-sm text-[#6B7280] leading-relaxed text-left font-['Inter',system-ui,-apple-system,sans-serif]">
                    Our method is based on the globally accepted 12- and 16-season color theory, used by professional stylists and image consultants.
                  </p>
                </div>
              </div>

              {/* Trust Point 2 */}
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#FFE6D1] rounded-lg flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-[#7C3A8D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <div className="text-left">
                  <h4 className="font-bold text-[#111827] mb-1 text-left font-['Inter',system-ui,-apple-system,sans-serif]">AI-Powered Technology</h4>
                  <p className="text-sm text-[#6B7280] leading-relaxed text-left font-['Inter',system-ui,-apple-system,sans-serif]">
                    We use advanced computer vision and machine learning to analyze your features with 99% accuracy and eliminate bias.
                  </p>
                </div>
              </div>

              {/* Trust Point 3 */}
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#FFE6D1] rounded-lg flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-[#7C3A8D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <div className="text-left">
                  <h4 className="font-bold text-[#111827] mb-1 text-left font-['Inter',system-ui,-apple-system,sans-serif]">Backed by 355,000+ Users</h4>
                  <p className="text-sm text-[#6B7280] leading-relaxed text-left font-['Inter',system-ui,-apple-system,sans-serif]">
                    Trusted by a global community who've used our analysis to upgrade their personal style with confidence.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Featured In Section */}
          <div className="text-left pt-6 border-t border-[#7C3A8D]/20">
            <h3 className="text-xl font-bold text-[#111827] mb-4 text-left tracking-wide font-['Inter',system-ui,-apple-system,sans-serif]">
              <span className="text-[#7C3A8D]">ColorAnalysis Pro</span> Has Been Featured In:
            </h3>
            <div className="flex items-center justify-start space-x-4 opacity-60">
              <img src={cosmoImg} alt="Cosmopolitan" className="h-8 grayscale" />
              <img src={vogueImg} alt="Vogue" className="h-4 grayscale" />
              <img src={marieclaireImg} alt="Marie Claire" className="h-16 grayscale" />
              <img src={elleImg} alt="Elle" className="h-8 grayscale" />
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center mb-8 px-4">
        <div className="max-w-[500px] text-center font-['Inter',system-ui,-apple-system,sans-serif]">
          <h2 className="text-2xl md:text-3xl font-bold text-[#111827] mb-4 leading-tight">
            Stop Wasting Precious Time
          </h2>
          <p className="text-lg text-[#6B7280] leading-relaxed">
            Discover your unique style blueprint and start feeling confident in every outfit you choose.
          </p>
        </div>
      </div>

      <div className="flex justify-center mb-4">
        <img src={beforeImg} alt="before" className="max-w-full w-[500px]" />
      </div>

      <div className="flex justify-center mb-4">
        <Button
          buttonStyles={`bg-[#7C3A8D] hover:bg-[#A259B5] text-white px-8 py-3 rounded-md font-bold text-base max-w-[350px] mb-4 inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-[#7C3A8D] focus:ring-offset-2 transition-colors duration-200`}
          text="GET MY COLORS NOW!"
          blick={false}
          action={() => onGetClick()}
        />
      </div>




      <div className="flex justify-center mb-4 -mx-4">
        <img src={analyzetImg} alt="analyzet" className="max-w-full w-full" />
      </div>

      <div className="flex justify-center mb-8 px-4">
        <div className="max-w-[500px] text-center font-['Inter',system-ui,-apple-system,sans-serif]">
          <h2 className="text-2xl md:text-3xl font-bold text-[#111827] mb-6 leading-tight">
            How You'll Benefit
          </h2>
          
          <div className="grid grid-cols-2 gap-6 mb-6">
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-[#FFE6D1] rounded-lg flex items-center justify-center mb-3">
                <svg className="w-8 h-8 text-[#7C3A8D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z" />
                </svg>
              </div>
              <p className="text-sm text-[#111827] text-center leading-relaxed">
                Look instantly more put-together with the right colors
              </p>
            </div>
            
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-[#FFE6D1] rounded-lg flex items-center justify-center mb-3">
                <svg className="w-8 h-8 text-[#7C3A8D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              </div>
              <p className="text-sm text-[#111827] text-center leading-relaxed">
                Enhance your personal brand and make lasting impressions
              </p>
            </div>
            
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-[#FFE6D1] rounded-lg flex items-center justify-center mb-3">
                <svg className="w-8 h-8 text-[#7C3A8D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <p className="text-sm text-[#111827] text-center leading-relaxed">
                Shop smarter—know what truly suits you
              </p>
            </div>
            
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-[#FFE6D1] rounded-lg flex items-center justify-center mb-3">
                <svg className="w-8 h-8 text-[#7C3A8D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                </svg>
              </div>
              <p className="text-sm text-[#111827] text-center leading-relaxed">
                Feel more confident in every outfit you wear
              </p>
            </div>
          </div>
          
          <p className="text-base text-[#111827] leading-relaxed">
            Transform how you look and feel with personalized color guidance
          </p>
        </div>
      </div>

      <div className="h-[2px] w-full mb-4 bg-[#232323]"></div>

      <div className="flex justify-center mb-4">
        <img src={seeImg} alt="see" className="max-w-full w-[500px]" />
      </div>

      <div className="flex justify-center mb-4 -mx-4">
        <img src={resultImg} alt="result" className="max-w-full w-[500px]" />
      </div>



      <div className="flex justify-center mb-4 ">
        <img src={bloggersImg} alt="blog" className="max-w-full w-[500px]" />
      </div>

      <div className="flex justify-center mb-4">
        <Button
          buttonStyles={`bg-[#7C3A8D] hover:bg-[#A259B5] text-white px-8 py-3 rounded-md font-bold text-base max-w-[350px] mb-4 inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-[#7C3A8D] focus:ring-offset-2 transition-colors duration-200`}
          text="GET MY COLORS NOW!"
          blick={false}
          action={() => onGetClick()}
        />
      </div>

      {showPromoCode && (
        <div className="my-4 rounded-[8px] bg-[#CAEFF9] px-5 py-4">
          {discountBlockRender()}
        </div>
      )}

      {false && (
      <div>
        <div
          ref={discountBlockRef}
          className={
            "rounded-[8px] border-[2px] border-[#DBE6E2] px-4 pb-[22px] pt-8"
          }
        >
          <p className={"mb-6 text-[16px] leading-5 text-[#0A364A] text-left"}>
            We've helped thousands of women discover their style and glow with
            confidence, and now we want to help you too 🔥
          </p>
          <p
            className={
              "mb-6 text-[16px] font-[900] leading-5 text-[#0A364A] text-left"
            }
          >
            We believe money shouldn't be a barrier to feeling fabulous and
            finally solving wardrobe challenges once and for all. So, choose the
            amount you think is reasonable to try us for 1 week ❤️❤️❤️
          </p>

          <p
            className={
              "mb-6 text-[16px] font-[900] leading-5 text-[#BD4192] text-left"
            }
          >
            It costs us $9.78 to cover our expenses for the trial, but we want
            you to pick a price that you're comfortable with.
          </p>

          <div
            className={
              "mb-1 mr-3 flex justify-end text-[14px] leading-5 text-[#6894A8]"
            }
          >
            most popular choice*
          </div>

          <div className={"mb-6 flex justify-between"}>
            {landingPlans.map((item, index) => {
              return (
                <div
                  onClick={() => {
                    onPlanClick(item);
                  }}
                  className={`w-[48%] rounded-[8px] border border-[#DBE6E2] bg-[#F5F7F8] py-4 transition duration-300 ${
                    plan === item.value ? "!border-[#08A0C8] !bg-[#E0EEF1]" : ""
                  }`}
                  key={`${index}-plan`}
                >
                  <p
                    className={
                      "text-center text-[16px] font-[900] leading-[22px]"
                    }
                  >
                    {item.text}
                  </p>
                </div>
              );
            })}
          </div>

          <div className="mb-6">
            <Elements stripe={stripePromise}>
              <AppleGooglePayButton
            trialOffer={plan === "0.99" ? trialOffer : undefined}
            paymentAmount={plan === "0.99" ? pricing.amount : undefined}
            paymentValue={plan === "0.99" ? pricing.purchaseValue : undefined}
                trialCost={plan}
                onSuccess={onSuccess}
                isDisabled={!plan}
              />
            </Elements>
          </div>

          {isApplePayAvailible === false ? (
            <div>
              <Button
                buttonStyles={
                  "bg-[#7C3A8D] hover:bg-[#A259B5] text-white px-8 py-3 rounded-md font-bold text-base mb-4 inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-[#7C3A8D] focus:ring-offset-2 transition-colors duration-200"
                }
                text="GET MY COLORS NOW!"
                isButtonDisabled={!plan}
                action={() => onPopupOpenClick()}
              />
              <p
                className={
                  "text-center text-[16px] leading-[22px] text-[#3E636C]"
                }
              >
                *7-day trial
              </p>

              <p className="text-[rgb(165,165,165)] text-[12px] leading-[14px] text-left mt-2">
                By continue you agree that after the 7-day trial period ends,
                Color-analysis.pro will automatically continue your membership
                and charge 29.99$ every 2 months until you cancel it online in
                the{" "}
                <a
                  href="https://app.color-analysis.pro"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#1f497d] underline"
                >
                  {" "}
                  personal account
                </a>{" "}
                or by email. Learn more about cancellation and refund policy in{" "}
                <a
                  href="https://color-analysis.pro/terms#subscription"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#1f497d] underline"
                >
                  {" "}
                  Subscription Terms
                </a>
                .
              </p>
            </div>
          ) : (
            <div
              className={`relative ${
                plan === null ? "h-0 max-h-0" : "h-[auto] !max-h-[750px]"
              } transiton overflow-hidden duration-300`}
            >
              <div className={`relative`}>
                <div>{renderFullForm(true)}</div>
              </div>

              <div>
                <p
                  onClick={() => setPopupOpen(true)}
                  className="cursor-pointer text-center text-[16px] font-[500] text-[#0A364A] underline"
                >
                  Continue with other payment options
                </p>
              </div>

              <p className="text-[rgb(165,165,165)] text-[12px] leading-[14px] text-left mt-2">
                By continue you agree that after the 7-day trial period ends,
                Color-analysis.pro will automatically continue your membership
                and charge 29.99$ every 2 months until you cancel it online in
                the{" "}
                <a
                  href="https://app.color-analysis.pro"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#1f497d] underline"
                >
                  {" "}
                  personal account
                </a>{" "}
                or by email. Learn more about cancellation and refund policy in{" "}
                <a
                  href="https://color-analysis.pro/terms#subscription"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#1f497d] underline"
                >
                  {" "}
                  Subscription Terms
                </a>
                .
              </p>
            </div>
          )}
        </div>
      </div>
      )}

      <div className="flex justify-center mb-10 ">
        <img src={visaImg} alt="visa" className="max-w-full w-[500px]" />
      </div>

      {isPopupOpen ? (
        <Popup
          content={<div className="pt-4">{renderPopupForm()}</div>}
          isOpen={isPopupOpen}
          closeFunction={() => onClosePopupClick()}
        />
      ) : null}

      {/* Sticky Bottom Button */}
      {showStickyButton && (
        <div className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-500 ${showStickyButton ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}>
          <div className="w-full bg-gradient-to-r from-[#F8F6F0] to-white border-t border-[#7C3A8D]/20 px-4 py-4 shadow-lg">
            <div className="max-w-sm mx-auto">
              <Button
                buttonStyles={`w-full bg-[#7C3A8D] hover:bg-[#A259B5] text-white px-6 py-3 rounded-lg font-bold text-base inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-[#7C3A8D] focus:ring-offset-2 transition-all duration-300 shadow-lg transform animate-pulse-scale hover:animate-none hover:scale-105`}
                text="🌈 GET MY COLOR ANALYSIS NOW!"
                blick={false}
                action={() => onGetClick()}
              />
            </div>
          </div>
        </div>
      )}
      </div>
    </div>
  );
}

export default PaywallV2;

